import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const GovernmentDocForm = ({ initialValues, onSuccess, editMode }) => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [imageList, setImageList] = useState([]);

    useEffect(() => {
        if (initialValues) {
            const newInitialValues = {
                ...initialValues,
            };
            
            if (typeof initialValues.image === 'string') {
                setImageList([
                    {
                        uid: '-1',
                        name: 'image.jpg',
                        status: 'done',
                        url: `${BASE_URL}${initialValues.image}`,
                    },
                ]);
            } 
            
            if (typeof initialValues.file_url === 'string') {
                setFileList([
                    {
                        uid: '-1',
                        name: 'file',
                        status: 'done',
                        url: `${BASE_URL}${initialValues.file_url}`,
                    },
                ]);
            }

            form.setFieldsValue(newInitialValues);
        } else {
            form.resetFields();
            setFileList([]);
            setImageList([]);
        }
    }, [initialValues, form]);

    const handleFinish = async (values) => {
        const formData = new FormData();
        formData.append('title', values.title);
        if (imageList.length > 0) {
            formData.append('image', imageList[0].originFileObj);
        }
        if (fileList.length > 0) {
            formData.append('file_url', fileList[0].originFileObj);
        }
        await onSuccess(formData);
        form.resetFields();
        setFileList([]);
        setImageList([]);
    };

    return (
        <Form 
            form={form}
            layout='vertical'
            onFinish={handleFinish}
        >
            <Form.Item
                label="Title"
                name="title"
            >
                <Input placeholder='Input Title' />
            </Form.Item>

            <Form.Item
                label="Image"
                name="image"
            >
                <Upload
                    beforeUpload={() => false}
                    fileList={imageList}
                    onChange={({ fileList }) => setImageList(fileList)}
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>Upload Gambar</Button>
                </Upload>
            </Form.Item>

            <Form.Item
                label="File"
                name="file_url"
            >
                <Upload
                    beforeUpload={() => false}
                    fileList={fileList}
                    onChange={({ fileList }) => setFileList(fileList)}
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>Upload File</Button>
                </Upload>
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
                <Button
                    htmlType='submit'
                    style={{
                        backgroundColor: '#ec4899',
                        borderColor: '#ec4899',
                        color: '#fff',
                    }}
                >
                   {editMode ? "Update" : "Add"}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default GovernmentDocForm;